import { render } from "./QuickRenameInput.vue?vue&type=template&id=af87f184&scoped=true"
import script from "./QuickRenameInput.vue?vue&type=script&lang=js"
export * from "./QuickRenameInput.vue?vue&type=script&lang=js"

import "./QuickRenameInput.vue?vue&type=style&index=0&id=af87f184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af87f184"]])

export default __exports__